import { pluralithAuth, pluralithStore } from "@/firebase/firebase"
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore"

const dbModule = {
  state: {},
  mutations: {},
  actions: {
    // General
    async getProviderList({ commit }: { commit: Function }) {
      if (pluralithAuth.currentUser) {
        try {
          let providerListRef = doc(pluralithStore, 'api', 'meta')
          let providerListDoc = await getDoc(providerListRef)
          let providerListData = providerListDoc.data()
          
          if (providerListData) commit('updateProviders', Object.values(providerListData.providerList))
          
          return 200
        } catch(error: any) {
          console.error(error)
          return 400
        }
      }
    },

    // Labeling
    async getProviderTemplate({ rootState }: { rootState: any }) {
      if (pluralithAuth.currentUser) {
        try {
          let providerTemplateRef = doc(pluralithStore, 'api', 'meta', 'labels', rootState.currentProvider.name)
          let providerTemplateDoc = await getDoc(providerTemplateRef)
          let providerTemplateData = providerTemplateDoc.data()

          return providerTemplateData
        } catch(error: any) {
          console.error(error)
          return 400
        }
      }
    },
    async getUserTemplate({ rootState, commit }: { rootState: any, commit: Function }) {
      if (pluralithAuth.currentUser) {
        try {
          let userTemplateRef = doc(pluralithStore, 'api', 'meta', 'labels', rootState.currentProvider.name, 'user_labeled', pluralithAuth.currentUser.uid)
          let userTemplateDoc = await getDoc(userTemplateRef)
          let userTemplateData = userTemplateDoc.data()

          if (userTemplateData) {
            commit('updateCurrentProviderResources', Object.values(userTemplateData.resources))
            console.log('existing user template found')
          }

          return 200
        } catch(error: any) {
          console.error(error)
          return 400
        }
      }
    },
    async initUserTemplate({ rootState, commit, dispatch }: { rootState: any, commit: Function, dispatch: Function }) {
      // Copy given provider template to api/meta/providers/$PROVIDER/user_labels/$USER_ID
      if (pluralithAuth.currentUser) {
        try {
          let providerTemplate = await dispatch('getProviderTemplate')
  
          let userTemplate = {
            timestamp: Date.now(),
            merged: false,
            resources: providerTemplate.template
          }
  
          let userTemplateRef = doc(pluralithStore, 'api', 'meta', 'labels', rootState.currentProvider.name, 'user_labeled', pluralithAuth.currentUser.uid)
          await setDoc(userTemplateRef, userTemplate)
  
          commit('updateCurrentProviderResources', Object.values(userTemplate.resources))
  
          console.log('user template initialized')
          return 200
        } catch(error: any) {
          console.error(error)
          return 400
        }
      }
    },

    async updateTemplateResource({ rootState }: { rootState: any }, resource: any) {
      if (pluralithAuth.currentUser) {
        try {
          let userTemplateRef = doc(pluralithStore, 'api', 'meta', 'labels', rootState.currentProvider.name, 'user_labeled', pluralithAuth.currentUser.uid)
          await updateDoc(userTemplateRef, {
            ['latestResource']: resource.resourceType,
            ['merged']: false,
            [`resources.${resource.resourceType}`]: resource
          })

          console.log(`resource ${resource.resourceType} updated`)
          return 200
        } catch(error: any) {
          console.error(error)
          return 400
        }
      }
      // Update a resource in user's provider template
      // + update latestResource key
      // + update completion percentage
    }


  },
  getters: {}
}

export default dbModule